import { inject } from '@angular/core';
import { TeacherApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const teacherShiftHistoryTableConfig = (): TableConfig => {
  const teacherApiService = inject(TeacherApiService);

  return {
    title: 'Lịch sử ca làm việc giáo viên',
    entityName: 'lịch sử ca làm việc giáo viên',
    service: teacherApiService,
    method: 'getTeacherShiftHistories',
    columns: [
      { field: 'employee.code', header: 'Mã NV', width: 'min-w-[80px]', sortable: true, type: 'text' },
      { field: 'profile.fullname', header: 'Họ tên', width: 'min-w-[180px]', sortable: true, type: 'text' },
      { field: 'profile.nickname', header: 'Nickname', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'shift', header: 'Ca làm việc', width: 'min-w-[120px]', sortable: true, type: 'text' },
      { field: 'available', header: 'Có sẵn', width: 'min-w-[100px]', sortable: true, type: 'boolean' },
      { field: 'fromDate', header: 'Từ ngày', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.TEACHER_EDIT.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
